import { render, staticRenderFns } from "./MoreManagementDialog.vue?vue&type=template&id=ab2ab36e&scoped=true&"
import script from "./MoreManagementDialog.vue?vue&type=script&lang=js&"
export * from "./MoreManagementDialog.vue?vue&type=script&lang=js&"
import style0 from "./MoreManagementDialog.vue?vue&type=style&index=0&id=ab2ab36e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2ab36e",
  null
  
)

export default component.exports